<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full md:bg-white md:rounded-lg md:shadow-l md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Le mie richieste</h1>

      <button (click)="onNavigate('form')" class="button">
        <span class="hidden md:inline">Nuova Richiesta</span>
        <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M12 5v14"/>
        </svg>
      </button>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

    <div class="shadow-lg overflow-auto w-full">
      <div class="grid w-full gap-x-8 gap-y-6 px-6 py-3 table-grid">
        <div class="table-header-row" (click)="setOrder('id')">ID <span *ngIf="currentSort.field === 'id'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span> </div>
        <div class="table-header-row" (click)="setOrder('name')">Nome  <span *ngIf="currentSort.field === 'name'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('code')">Codice  <span *ngIf="currentSort.field === 'code'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('state')">Stato  <span *ngIf="currentSort.field === 'state'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>
        <div class="table-header-row" (click)="setOrder('create_date')">Data  <span *ngIf="currentSort.field === 'create_date'">{{ currentSort.direction === 'asc' ? '&#9650;' : '&#9660;'}}</span></div>

      @for (request of pagedData; track request.id) {
        <div class="contents hover:bg-gray-100 odd:bg-white even:bg-gray-50 cursor-pointer whitespace-nowrap text-sm text-gray-900"
             (click)="onRowClicked(request.id)">
          <div>{{ request.id }}</div>
          <div>{{ request.label | truncate }}</div>
          <div>{{ request.code }}</div>
          <div>{{ request.state.label }}</div>
          <div>{{ request.date | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        </div>
      }
      </div>
    </div>

    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pagination>

    <div class="flex items-center justify-end mb-8">
      <button (click)="fetchRequests({})" class="button">
        Aggiorna Elenco
      </button>
    </div>

  </div>
</div>
